import { CONSOLE_PATHS, PRODUCT_NAME } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import type { AuthHeaderPrompt } from "./auth-layout";

/** Top-bar prompt of the sign-in family (login, forgot, reset): "New to Sagot? Create an account". */
export function useCreateAccountPrompt(): AuthHeaderPrompt {
  const { t } = useTranslation();
  return { text: t("auth.login.newHere", { product: PRODUCT_NAME }), label: t("auth.login.createAccount"), href: CONSOLE_PATHS.register };
}
